<div class="modal-header">
    <h4 class="modal-title">Produktivitets formler</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <div class="d-flex align-items-center">
        <button class="btn btn-primary btn-sm btn--menu ms-2 me-2" (click)="createFormel()">
            <i class="fa-solid fa-plus"></i>
        </button>
        <p>Tilladte tegn:ABCDEFGHIJ0123456789+-*/() Pas på ikke at lave formler der dividerer med 0</p>
    </div>

    <div class="table__viewport">
        <table class="table table-hover table-striped table-sm table-frame__body" >

            <thead>

                <tr>
                    <th>Betegnelse</th>
                    <th>Formel</th>
                    <th class="text-center">Opdater</th>
                    <th class="text-center">Slet</th>
                </tr>
            </thead>

            <tbody>
                <ng-container *ngFor="let formel of listOfFormels$ | async">
                    <tr>
                        <td>
                            <input placeholder="Ny Custom" #describtionInputField [value]="formel.betegnelse">
                        </td>
                        <td>
                            <input placeholder="B-A" #formulaInputField [value]="formel.formel">
                        </td>
                        <td class="text-center">
                            <button class="btn" style="background-color: transparent; border: none;" (click)="editFormel(formel.id, describtionInputField.value, formulaInputField.value)">
                                <i class="fa-solid fa-rotate-right"></i>
                            </button>
                        </td>
                        <td class="text-center">
                            <button class="btn" style="background-color: transparent; border: none;" (click)="removeFormel(formel)">
                                <i class="fa fa-x"></i>
                            </button>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
